import PropTypes from 'prop-types'
import Button from './Button'

const Header = ({title, onAdd, showAdd}) => {
 //const onClick = () => {
   //console.log('Click')
 //}

  return (
      <header className='header'>
         <h1> {title}</h1>
         <Button 
         color ={showAdd ?'pink': '#4E9C81'}
         text ={showAdd ?'Close': 'Add'}
         onClick={onAdd}/>
         </header>
    //passing color we need text prop
  )
}
 //<h1 style={{color:'red', backgroundColor:'green'}}> {title}</h1>
Header.defaultProps ={
  title: 'Task Tracker',
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
}
//css in JS but need to write and pass  <h1 style={headingStyle}> {title}</h1>
//const headingStyle = {
 // color: 'red',
 // backgroundColor: 'green'
//}
export default Header 

